import React from 'react';

export type LicenseType =
  | 'standard'
  | 'pro'
  | 'business'
  | 'enterprise'
  | 'none';

export const licenseConfig: Record<
  LicenseType,
  { label: string; badgeClass: string; dotClass: string }
> = {
  standard: {
    label: 'Standard',
    badgeClass: 'badge badge-starter',
    dotClass: 'badge-dot dot-starter',
  },
  pro: {
    label: 'Pro',
    badgeClass: 'badge badge-pro',
    dotClass: 'badge-dot dot-pro',
  },
  business: {
    label: 'Business',
    badgeClass: 'badge badge-business',
    dotClass: 'badge-dot dot-business',
  },
  enterprise: {
    label: 'Enterprise',
    badgeClass: 'badge badge-enterprise',
    dotClass: 'badge-dot dot-enterprise',
  },
  none: {
    label: 'No License',
    badgeClass: 'badge badge-none',
    dotClass: 'badge-dot dot-none',
  },
};

interface LicenseBadgeProps {
  license: LicenseType;
}

const LicenseBadge: React.FC<LicenseBadgeProps> = ({ license }) => {
  const config = licenseConfig[license];
  return (
    <span className={config.badgeClass}>
      <span className={config.dotClass} />
      {config.label}
    </span>
  );
};

export default LicenseBadge;
